<template>
  <a-pagination
    :total="total"
    :show-total="total => `Total rows: ${totalLengthPerPage} From ${total} items`"
    :page-size="pageSize"
    :default-current="defaultPage"
    @change="handleChangePage"
  />
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total: {
      type: Number,
    },
    pageSize: {
      type: Number,
    },
    totalLengthPerPage: {
      type: Number,
    },
    defaultPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    handleChangePage (page, pageSize) {
      this.$emit('changePage', page)
    },
  },
}
</script>
